import {Component} from '@angular/core';
import {EMPTY_CHART_COLOR} from '../empty-chart-config';

@Component({
    selector: 'ngx-empty-bar-chart-stacked-single',
    templateUrl: './bar-chart-stacked-single.component.html',
    styleUrls: ['./bar-chart-stacked-single.component.scss', '../common-theme-empty-charts.scss'],
})
export class EmptyBarChartStackedSingleComponent {
    textBackGroundColor = EMPTY_CHART_COLOR.color;
    barColor = EMPTY_CHART_COLOR.color;
    transparent = EMPTY_CHART_COLOR.transparent;

    legendTextStyle = {
        color: this.transparent,
        backgroundColor: this.textBackGroundColor,
        borderRadius: 3,
    };

    chartOptions = {
        animation: false, // disable to loading animation
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow',
            },
        },
        title: {
            x: 'center',
            text: 'Chart Title',
            textStyle: {
                fontSize: 14,
                color: this.transparent,
                width: 500,
            },
            backgroundColor: this.textBackGroundColor,
            borderRadius: 6,
        },
        legend: {
            data: [
                {
                    name: 'Legend 1',
                    icon: 'none',
                    textStyle: this.legendTextStyle,
                },
                {
                    name: 'Legend 2',
                    icon: 'none',
                    textStyle: this.legendTextStyle,
                },
                {
                    name: 'Legend 3',
                    icon: 'none',
                    textStyle: this.legendTextStyle,
                },
            ],
            y: 'bottom',
        },
        grid: {
            top: 30,
            left: -10,
            right: 0,
            bottom: 30,
        },
        xAxis: {
            type: 'value',
            show: false,
            splitLine: {
                show: true,
            },
        },
        yAxis: {
            type: 'category',
            data: [
                {
                    value: 'yAxis Label',
                    textStyle: {
                        borderRadius: 3,
                        borderColor: this.textBackGroundColor,
                        backgroundColor: this.textBackGroundColor,
                        color: this.transparent,
                    },
                },
            ],
        },
        series: [
            {
                name: 'Legend 1',
                type: 'bar',
                stack: 'total',
                label: {
                    show: true,
                },
                emphasis: {
                    focus: 'series',
                },
                data: [
                    {
                        value: 5,
                        label: {
                            show: false,
                        },
                        itemStyle: {
                            color: this.barColor,
                        },
                    },
                ],
            },
            {
                name: 'Legend 2',
                type: 'bar',
                stack: 'total',
                label: {
                    show: true,
                },
                emphasis: {
                    focus: 'series',
                },
                data: [],
            },
            {
                name: 'Legend 3',
                type: 'bar',
                stack: 'total',
                label: {
                    show: true,
                },
                emphasis: {
                    focus: 'series',
                },
                data: [],
            },
        ],
    };
}
